export default "__VITE_ASSET__eecc625b__"